import React, { useEffect, useState } from "react";
import UserInfoCards from "../../components/composite/UserInfoCards";
import Header from "../../sharedScreens/Header";
import SideMenu from "../../sharedScreens/menuItems/SideMenu";
import { msgTypes } from "../../constants/msgTypes";
import { UtilService } from "../../services/shared/UtilService";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import Pagination from "@mui/material/Pagination"; // Import Pagination component
import InputLabel from "@mui/material/InputLabel";
import { MuiDropDown } from "../../components/basicComponent/MuiDropDown";
import MuiButton from "../../components/basicComponent/MuiButton";
import UserListFilter from "../../components/composite/UserListFilter";
import { branchList, statusList } from "../../constants/constant";
import useCompanyList from "../../services/customHooks/useCompanyList";
import useUserName from "../../services/customHooks/useUserName";
import ConfirmationModal from "../../components/basicComponent/ConfirmationModal";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import AssignCommissionPopup from "../../components/basicComponent/AssignCommissionPopup";
import { MuiInput } from "../../components/basicComponent/MuiInput";
import ActivityIndicator from "../../components/basicComponent/ActivityIndicator";
import NoDataFlightCard from "../../components/composite/NoDataFlightCard";
import { useSweetAlert } from "../../services/customHooks/useSweetAlert";

type User = {
  username: string;
  roleName: string;
  branch: string;
  id: string;
  mobileNumber: string;
  defaultCustomer: string;
  status: string;
  createdAt: string;
  corporate: string;
  user: {
    firstName: string;
    lastName: string;
    email: string;
  };
  employeeCode?: string;
};

const UserInfoList = () => {
  const [userList, setUserList] = useState<User[]>([]);
  const [currentPage, setCurrentPage] = useState(1); // State for current page
  const [itemsPerPage] = useState(5); // Number of items per page
  const [userNameList, setUserNameList] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { showInfo } = useSweetAlert();

  useEffect(() => {
    const param = {
      status: true,
    };
    getUserList(param);
    getUserNameList();
  }, []);

  const getUserList = async (param?: {}) => {
    setLoading(true); // START loading
    const response = await UtilService.getUserList(param);
    if (response.statusMsg === msgTypes.SUCCESS.msg) {
      setUserList(response?.data);
    }
    setLoading(false); // END loading
  };

  const handleClick = (id: string) => {
    const userData = userList?.filter((i) => i?.id === id);
    navigate("/usermanagement", {
      state: {
        data: userData,
      },
    });
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = userList?.slice(indexOfFirstItem, indexOfLastItem);
  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setCurrentPage(page);
  };
  const [selectedBranch, setSelectedBranch] = useState<string>("");
  const { data: corporateList, error } = useCompanyList(selectedBranch || {});

  const [selectedUserName, setSelectedUserName] = useState("");
  const [selectedCorporateId, setSelectedCorporateId] = useState("");
  const [selectedMobile, setSelectedMobile] = useState("");
  const [selectedUserNameId, setSelectedUserNameId] = useState("");
  const [selectedUserStatus, setSelectedUserStatus] = useState("");

  const handleMobileChange = (value: string) => {
    setSelectedMobile(value);
  };

  const handleUserName = (value: string) => {
    setSelectedUserName(value);
  };

  const handleUserStatusChange = (value: string, id: any) => {
    setSelectedUserStatus(value);
  };

  const handleGetClick = () => {
    const isNameSelected = selectedUserName?.trim() !== "";
    const isStatusSelected = selectedUserStatus?.trim() !== "";
    const isMobileSelected = selectedMobile?.trim() !== "";

    if (!isNameSelected && !isStatusSelected && !isMobileSelected) {
      showInfo(
        "",
        "Please select at least one filter: User Name, Mobile, or Status."
      );
      return;
    }

    const payload = {
      fullName: isNameSelected ? selectedUserName : null,
      status: isStatusSelected ? selectedUserStatus === "active" : null,
      mobileNo: isMobileSelected ? selectedMobile : null,
    };

    getUserList(payload);
  };

  const handleClearClick = () => {
    if (!selectedUserName && !selectedUserStatus && !selectedMobile) {
      showInfo("", "Nothing to clear. All filters are already empty.");
      return;
    }

    setSelectedUserName("");
    setSelectedUserStatus("");
    setSelectedMobile("");

    const param = {
      status: true,
    };
    getUserList(param);
  };

  const getUserNameList = async () => {
    const response = await UtilService.getUserList();

    if (response.statusMsg === msgTypes.SUCCESS.msg) {
      const data = response?.data?.map((i: any) => ({
        label: i?.user?.firstName + " " + i?.user?.lastName,
        value: i?.user?.firstName + " " + i?.user?.lastName,
      }));
      setUserNameList(data);
    }
  };

  return (
    <>
      <div className="grow">
        <SideMenu />
        <div className="wrapper flex grow flex-col">
          <Header />
          <main className="grow content" id="content" role="content">
            <div className="container-fixed">
              <div className="card-header mb-1 managebookingg">
                <h3 className="card-title titlecolorr">User List</h3>
              </div>
              <div className="card card-custom mb-5">
                <div className="card-body">
                  <div className="row  align-items-end">
                    {/* Corporate Dropdown */}
                    <div className="col-md-3 mb-2 user-manage-model">
                      <MuiDropDown
                        placeholder="Select User Name"
                        onChange={handleUserName}
                        options={userNameList}
                        label="User Name"
                        value={selectedUserName}
                      />
                    </div>

                    {/* Mobile Input */}
                    <div className="col-md-3 mb-2 user-manage-model">
                      <MuiInput
                        placeholder="Mobile Number"
                        onChange={handleMobileChange}
                        label="Mobile"
                        value={selectedMobile}
                      />
                    </div>

                    {/* User Status Dropdown */}
                    <div className="col-md-3 mb-2 user-manage-model">
                      <MuiDropDown
                        placeholder="Select User Status"
                        onChange={handleUserStatusChange}
                        options={statusList}
                        label="User Status"
                        value={selectedUserStatus}
                      />
                    </div>

                    {/* Action Buttons */}
                    <div className="col-md-3 user-button mb-2 d-flex gap-2">
                      <MuiButton
                        className="get-btn w-full"
                        label="Get"
                        type="submit"
                        onClick={handleGetClick}
                        style={{ width: "-webkit-fill-available" }}
                      />
                      <MuiButton
                        className="clear-btn w-full"
                        label="Clear"
                        type="submit"
                        onClick={handleClearClick}
                        style={{ width: "-webkit-fill-available" }}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 d-flex justify-content-between">
                      <h4 className="text-lg text-gray-800 font-semibold">
                        {` Total Users: ${userList?.length}`}
                      </h4>
                    </div>

                    <div className="col-md-12 scrollable-x-auto">
                      <table className="table table-bordered mt-3 shadow-sm">
                        <thead className="table-light  text-center">
                          <tr>
                            <th>Username</th>
                            <th>Email</th>
                            <th>Mobile</th>
                            <th>Employee Code</th>
                            <th>Created Date</th>
                            <th>Created By</th>
                            <th>Welcome Mail</th>
                            <th>Status</th>
                            <th>Edit</th>
                          </tr>
                        </thead>

                        <tbody>
                          {loading ? (
                            <tr>
                              <td colSpan={8}>
                                <div className="d-flex justify-content-center align-items-center py-4">
                                  <ActivityIndicator />
                                </div>
                              </td>
                            </tr>
                          ) : currentItems && currentItems.length > 0 ? (
                            currentItems.map((user, index) => (
                              <UserInfoCards
                                key={index}
                                getUserList={() => {
                                  setSelectedUserStatus("");
                                  setSelectedMobile("");

                                  const param = {
                                    status: true,
                                  };
                                  getUserList(param);
                                }}
                                className="mt-2"
                                username={
                                  user.user.firstName +
                                  "  " +
                                  user?.user.lastName
                                }
                                rolename={user.roleName}
                                branch={user.branch}
                                id={user.id}
                                email={user.user.email}
                                mobile={user.mobileNumber}
                                status={user.status}
                                createdAt={user.createdAt}
                                createdBy={user.corporate}
                                handleEditClick={() => handleClick(user?.id)}
                                employeeCode={user?.employeeCode}
                              />
                            ))
                          ) : (
                            <tr>
                              <td colSpan={8}>
                                {/* Adjust the number to match your column count */}
                                <NoDataFlightCard headingText="No Data Found" />
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>

                    <div className="row">
                      <div className="col-md-12 d-flex justify-content-end my-2 ">
                        <Pagination
                          count={Math.ceil(userList?.length / itemsPerPage)} // Total number of pages
                          page={currentPage}
                          onChange={handlePageChange}
                          color="primary"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/*-----------------pop code----------------------------  */}
            {/* <UserListFilter
              header={"Filter"}
              children={<FilterPopUp />}
              isVisible={open}
              handleClose={() => handleClose()}
            /> */}

            {/* <ConfirmationModal
              header="Delete Folder?"
              subText="Are you sure you want to delete this folder? This action cannot be undone."
              isVisible={open}
              handleClose={() => handleClose()}
              IconComponent={
                <WarningAmberIcon color="error" sx={{ fontSize: 40, mb: 1 }} />
              }
              onConfirm={function (): void {
                throw new Error("Function not implemented.");
              }}
            /> */}

            {/* <AssignCommissionPopup
              subText="Are you sure you want to delete this folder? This action cannot be undone."
              isVisible={open}
              handleClose={() => handleClose()}
              mainHead={"Main Heading"}
              onConfirm={function (): void {
                throw new Error("Function not implemented.");
              }}
              header={""}
            /> */}
          </main>
        </div>
      </div>
    </>
  );
};

export default UserInfoList;
